export default __webpack_public_path__ + "images/0d80daf6d14b560f9685d69492302136.png";